import {BACKEND_API_ROOT} from "@constants/laravel-backend-endpoints";

export const BACKEND_EP_CONTACT_SUBMISSION_NEW = `${BACKEND_API_ROOT}/front-end/contact-submission/new`;